import _slicedToArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "proto/common/account.proto" (package "proto.common", syntax proto3)
// tslint:disable
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { BusinessFormType } from "./business_form_type_pb";
import { Date } from "@finam/tx-proto-grpc-proto/google/type/date_pb";
import { Tariff } from "./tariff_pb";
import { AccountId } from "./account_id_pb";
/**
 * @generated from protobuf enum proto.common.Account.Type
 */

export var Account_Type;

(function (Account_Type) {
  /**
   * @generated from protobuf enum value: UNDEFINED = 0;
   */
  Account_Type[Account_Type["UNDEFINED"] = 0] = "UNDEFINED";
  /**
   * @generated from protobuf enum value: MMA = 1;
   */

  Account_Type[Account_Type["MMA"] = 1] = "MMA";
  /**
   * @generated from protobuf enum value: ETNA = 2;
   */

  Account_Type[Account_Type["ETNA"] = 2] = "ETNA";
  /**
   * @generated from protobuf enum value: MICEX = 3;
   */

  Account_Type[Account_Type["MICEX"] = 3] = "MICEX";
  /**
   * @generated from protobuf enum value: MICEX_CURRENCY = 4;
   */

  Account_Type[Account_Type["MICEX_CURRENCY"] = 4] = "MICEX_CURRENCY";
  /**
   * @generated from protobuf enum value: FORTS = 5;
   */

  Account_Type[Account_Type["FORTS"] = 5] = "FORTS";
  /**
   * @generated from protobuf enum value: UNION = 6;
   */

  Account_Type[Account_Type["UNION"] = 6] = "UNION";
  /**
   * @generated from protobuf enum value: SPBEX = 7;
   */

  Account_Type[Account_Type["SPBEX"] = 7] = "SPBEX";
  /**
   * @generated from protobuf enum value: USA = 8;
   */

  Account_Type[Account_Type["USA"] = 8] = "USA";
  /**
   * @generated from protobuf enum value: SPECULO = 9;
   */

  Account_Type[Account_Type["SPECULO"] = 9] = "SPECULO";
  /**
   * @generated from protobuf enum value: MT5 = 10;
   */

  Account_Type[Account_Type["MT5"] = 10] = "MT5";
})(Account_Type || (Account_Type = {}));
/**
 * @generated from protobuf enum proto.common.Account.OrderType
 */


export var Account_OrderType;

(function (Account_OrderType) {
  /**
   * @generated from protobuf enum value: MARKET = 0;
   */
  Account_OrderType[Account_OrderType["MARKET"] = 0] = "MARKET";
  /**
   * @generated from protobuf enum value: LIMIT = 1;
   */

  Account_OrderType[Account_OrderType["LIMIT"] = 1] = "LIMIT";
})(Account_OrderType || (Account_OrderType = {}));
/**
 * Счет в смысле блокировок может быть в четырех состояниях, по возрастанию уровня блокировки:
 *
 * @generated from protobuf enum proto.common.Account.AccountStatus
 */


export var Account_AccountStatus;

(function (Account_AccountStatus) {
  /**
   * понятно, все можно.
   *
   * @generated from protobuf enum value: ACCOUNT_ACTIVE = 0;
   */
  Account_AccountStatus[Account_AccountStatus["ACCOUNT_ACTIVE"] = 0] = "ACCOUNT_ACTIVE";
  /**
   * нельзя открывать позиции и выводить деньги. В это состояние попадают при маржин колле. Можно закрывать позиции, можно заводить деньги, но тратить их - нельзя.
   *
   * @generated from protobuf enum value: ACCOUNT_RESTRICTED = 10;
   */

  Account_AccountStatus[Account_AccountStatus["ACCOUNT_RESTRICTED"] = 10] = "ACCOUNT_RESTRICTED";
  /**
   * относительно редкая ситуация, когда ничего нельзя. Счет открыт, деньги и позиции на нем могут быть, но выставлять сделки нельзя никак.
   *
   * @generated from protobuf enum value: ACCOUNT_BLOCKED = 20;
   */

  Account_AccountStatus[Account_AccountStatus["ACCOUNT_BLOCKED"] = 20] = "ACCOUNT_BLOCKED";
  /**
   * ничего нельзя, счет закрыт, как будто нет его вообще. В таком состоянии как раз можно не показывать его.
   *
   * @generated from protobuf enum value: ACCOUNT_CLOSED = 30;
   */

  Account_AccountStatus[Account_AccountStatus["ACCOUNT_CLOSED"] = 30] = "ACCOUNT_CLOSED";
})(Account_AccountStatus || (Account_AccountStatus = {}));
/**
 * @generated from protobuf enum proto.common.Account.AccountProperties
 */


export var Account_AccountProperties;

(function (Account_AccountProperties) {
  /**
   * наличие ключа означает true
   *
   * @generated from protobuf enum value: CRYPTO_WALLET = 0;
   */
  Account_AccountProperties[Account_AccountProperties["CRYPTO_WALLET"] = 0] = "CRYPTO_WALLET";
  /**
   * @generated from protobuf enum value: MARGIN_TYPE = 1;
   */

  Account_AccountProperties[Account_AccountProperties["MARGIN_TYPE"] = 1] = "MARGIN_TYPE";
  /**
   * @generated from protobuf enum value: ACTIVE_TARIFF_CODE = 2;
   */

  Account_AccountProperties[Account_AccountProperties["ACTIVE_TARIFF_CODE"] = 2] = "ACTIVE_TARIFF_CODE";
  /**
   * наличие ключа означает true
   *
   * @generated from protobuf enum value: PROP_TRADING = 3;
   */

  Account_AccountProperties[Account_AccountProperties["PROP_TRADING"] = 3] = "PROP_TRADING";
  /**
   * номер счета в старом КлФ-*** формате
   *
   * @generated from protobuf enum value: OLD_TRADE_CODE = 4;
   */

  Account_AccountProperties[Account_AccountProperties["OLD_TRADE_CODE"] = 4] = "OLD_TRADE_CODE";
  /**
   * номер договора
   *
   * @deprecated
   * @generated from protobuf enum value: REG_NUMBER = 5 [deprecated = true];
   */

  Account_AccountProperties[Account_AccountProperties["REG_NUMBER"] = 5] = "REG_NUMBER";
  /**
   * дата заключения договора
   *
   * @deprecated
   * @generated from protobuf enum value: REG_DATE = 6 [deprecated = true];
   */

  Account_AccountProperties[Account_AccountProperties["REG_DATE"] = 6] = "REG_DATE";
  /**
   * @generated from protobuf enum value: J2T_BACKOFFICE_ID = 7;
   */

  Account_AccountProperties[Account_AccountProperties["J2T_BACKOFFICE_ID"] = 7] = "J2T_BACKOFFICE_ID";
  /**
   *  Торговля опционами, integer:
   *  0 - запрещено
   *  1 - ?
   *  2 - ?
   *  3 - ?
   *  4 - ?
   *  5 - ?
   *
   * @generated from protobuf enum value: OPTION_LEVEL = 8;
   */

  Account_AccountProperties[Account_AccountProperties["OPTION_LEVEL"] = 8] = "OPTION_LEVEL";
  /**
   * @generated from protobuf enum value: MARGIN_CATEGORY = 9;
   */

  Account_AccountProperties[Account_AccountProperties["MARGIN_CATEGORY"] = 9] = "MARGIN_CATEGORY";
  /**
   * см. поле AccountId.id
   *
   * @deprecated
   * @generated from protobuf enum value: EDOX_ACCOUNT_ID = 10 [deprecated = true];
   */

  Account_AccountProperties[Account_AccountProperties["EDOX_ACCOUNT_ID"] = 10] = "EDOX_ACCOUNT_ID";
  /**
   * @generated from protobuf enum value: CLEARING_FIRM = 11;
   */

  Account_AccountProperties[Account_AccountProperties["CLEARING_FIRM"] = 11] = "CLEARING_FIRM";
  /**
   * см. поле label
   *
   * @deprecated
   * @generated from protobuf enum value: USER_LABEL = 12 [deprecated = true];
   */

  Account_AccountProperties[Account_AccountProperties["USER_LABEL"] = 12] = "USER_LABEL";
  /**
   * Для Москвы см. proto.edox.accounts.AccountInfo.TariffInfo
   *
   * @deprecated
   * @generated from protobuf enum value: TARIFF_ID = 13 [deprecated = true];
   */

  Account_AccountProperties[Account_AccountProperties["TARIFF_ID"] = 13] = "TARIFF_ID";
  /**
   * @deprecated
   * @generated from protobuf enum value: PENDING_TARIFF_ID = 14 [deprecated = true];
   */

  Account_AccountProperties[Account_AccountProperties["PENDING_TARIFF_ID"] = 14] = "PENDING_TARIFF_ID";
  /**
   * Для Москвы см. proto.edox.accounts.ClientRiskLevelId
   *
   * @deprecated
   * @generated from protobuf enum value: RISK_KEVEL_ID = 15 [deprecated = true];
   */

  Account_AccountProperties[Account_AccountProperties["RISK_KEVEL_ID"] = 15] = "RISK_KEVEL_ID";
  /**
   * наличие ключа означает наличие регистра "инвестиционный продукт" у счета
   *
   * @generated from protobuf enum value: INVEST_PRODUCT = 16;
   */

  Account_AccountProperties[Account_AccountProperties["INVEST_PRODUCT"] = 16] = "INVEST_PRODUCT";
  /**
   * наличие ключа означает подключенный Lending Robot
   *
   * @generated from protobuf enum value: LENDING_ROBOT = 17;
   */

  Account_AccountProperties[Account_AccountProperties["LENDING_ROBOT"] = 17] = "LENDING_ROBOT";
  /**
   * наличие ключа означает счет выдан по программе Быстрого Старта
   *
   * @generated from protobuf enum value: QUICK_START = 18;
   */

  Account_AccountProperties[Account_AccountProperties["QUICK_START"] = 18] = "QUICK_START";
  /**
   * наличие ключа означает это US счет
   *
   * @generated from protobuf enum value: CUSTODIAN_MMA = 19;
   */

  Account_AccountProperties[Account_AccountProperties["CUSTODIAN_MMA"] = 19] = "CUSTODIAN_MMA";
})(Account_AccountProperties || (Account_AccountProperties = {})); // @generated message type with reflection information, may provide speed optimized methods


var Account$Type = /*#__PURE__*/function (_MessageType) {
  _inherits(Account$Type, _MessageType);

  var _super = _createSuper(Account$Type);

  function Account$Type() {
    _classCallCheck(this, Account$Type);

    return _super.call(this, "proto.common.Account", [{
      no: 1,
      name: "id",
      kind: "message",
      T: function T() {
        return AccountId;
      }
    }, {
      no: 2,
      name: "demo",
      kind: "scalar",
      T: 8
      /*ScalarType.BOOL*/

    }, {
      no: 3,
      name: "readonly",
      kind: "scalar",
      T: 8
      /*ScalarType.BOOL*/

    }, {
      no: 4,
      name: "type",
      kind: "enum",
      T: function T() {
        return ["proto.common.Account.Type", Account_Type];
      }
    }, {
      no: 5,
      name: "sub_accounts",
      kind: "message",
      repeat: 1
      /*RepeatType.PACKED*/
      ,
      T: function T() {
        return Account;
      }
    }, {
      no: 6,
      name: "order_types",
      kind: "enum",
      repeat: 1
      /*RepeatType.PACKED*/
      ,
      T: function T() {
        return ["proto.common.Account.OrderType", Account_OrderType];
      }
    }, {
      no: 7,
      name: "iis",
      kind: "scalar",
      T: 8
      /*ScalarType.BOOL*/

    }, {
      no: 8,
      name: "tariffs",
      kind: "message",
      repeat: 1
      /*RepeatType.PACKED*/
      ,
      T: function T() {
        return Tariff;
      }
    }, {
      no: 9,
      name: "status",
      kind: "enum",
      T: function T() {
        return ["proto.common.Account.AccountStatus", Account_AccountStatus];
      }
    }, {
      no: 10,
      name: "properties",
      kind: "map",
      K: 5
      /*ScalarType.INT32*/
      ,
      V: {
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/

      }
    }, {
      no: 11,
      name: "active_tariff",
      kind: "message",
      T: function T() {
        return Account_Tariff;
      }
    }, {
      no: 12,
      name: "pending_tariff",
      kind: "message",
      T: function T() {
        return Account_Tariff;
      }
    }, {
      no: 13,
      name: "transaq_template_id",
      kind: "scalar",
      T: 5
      /*ScalarType.INT32*/

    }, {
      no: 14,
      name: "firm_id",
      kind: "scalar",
      T: 5
      /*ScalarType.INT32*/

    }, {
      no: 15,
      name: "contract_id",
      kind: "scalar",
      T: 3
      /*ScalarType.INT64*/

    }, {
      no: 16,
      name: "contract_number",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 17,
      name: "contract_date",
      kind: "message",
      T: function T() {
        return Date;
      }
    }, {
      no: 18,
      name: "contract_end_date",
      kind: "message",
      T: function T() {
        return Date;
      }
    }, {
      no: 19,
      name: "label",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 20,
      name: "client_risk_level_id",
      kind: "scalar",
      T: 5
      /*ScalarType.INT32*/

    }, {
      no: 21,
      name: "alternate_name",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 22,
      name: "business_form_type",
      kind: "enum",
      T: function T() {
        return ["proto.common.BusinessFormType", BusinessFormType, "BUSINESS_FORM_TYPE_"];
      }
    }, {
      no: 23,
      name: "owner_id",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 24,
      name: "product_id",
      kind: "scalar",
      T: 5
      /*ScalarType.INT32*/

    }, {
      no: 25,
      name: "service_codes",
      kind: "scalar",
      repeat: 2
      /*RepeatType.UNPACKED*/
      ,
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(Account$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        demo: false,
        readonly: false,
        type: 0,
        subAccounts: [],
        orderTypes: [],
        iis: false,
        tariffs: [],
        status: 0,
        properties: {},
        transaqTemplateId: 0,
        firmId: 0,
        contractId: "0",
        contractNumber: "",
        label: "",
        clientRiskLevelId: 0,
        alternateName: "",
        businessFormType: 0,
        ownerId: "",
        productId: 0,
        serviceCodes: []
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag = reader.tag(),
            _reader$tag2 = _slicedToArray(_reader$tag, 2),
            fieldNo = _reader$tag2[0],
            wireType = _reader$tag2[1];

        switch (fieldNo) {
          case
          /* proto.common.AccountId id */
          1:
            message.id = AccountId.internalBinaryRead(reader, reader.uint32(), options, message.id);
            break;

          case
          /* bool demo */
          2:
            message.demo = reader.bool();
            break;

          case
          /* bool readonly */
          3:
            message.readonly = reader.bool();
            break;

          case
          /* proto.common.Account.Type type */
          4:
            message.type = reader.int32();
            break;

          case
          /* repeated proto.common.Account sub_accounts */
          5:
            message.subAccounts.push(Account.internalBinaryRead(reader, reader.uint32(), options));
            break;

          case
          /* repeated proto.common.Account.OrderType order_types */
          6:
            if (wireType === WireType.LengthDelimited) for (var e = reader.int32() + reader.pos; reader.pos < e;) {
              message.orderTypes.push(reader.int32());
            } else message.orderTypes.push(reader.int32());
            break;

          case
          /* bool iis */
          7:
            message.iis = reader.bool();
            break;

          case
          /* repeated proto.common.Tariff tariffs = 8 [deprecated = true];*/
          8:
            message.tariffs.push(Tariff.internalBinaryRead(reader, reader.uint32(), options));
            break;

          case
          /* proto.common.Account.AccountStatus status */
          9:
            message.status = reader.int32();
            break;

          case
          /* map<int32, string> properties */
          10:
            this.binaryReadMap10(message.properties, reader, options);
            break;

          case
          /* proto.common.Account.Tariff active_tariff */
          11:
            message.activeTariff = Account_Tariff.internalBinaryRead(reader, reader.uint32(), options, message.activeTariff);
            break;

          case
          /* proto.common.Account.Tariff pending_tariff */
          12:
            message.pendingTariff = Account_Tariff.internalBinaryRead(reader, reader.uint32(), options, message.pendingTariff);
            break;

          case
          /* int32 transaq_template_id */
          13:
            message.transaqTemplateId = reader.int32();
            break;

          case
          /* int32 firm_id */
          14:
            message.firmId = reader.int32();
            break;

          case
          /* int64 contract_id */
          15:
            message.contractId = reader.int64().toString();
            break;

          case
          /* string contract_number */
          16:
            message.contractNumber = reader.string();
            break;

          case
          /* google.type.Date contract_date */
          17:
            message.contractDate = Date.internalBinaryRead(reader, reader.uint32(), options, message.contractDate);
            break;

          case
          /* google.type.Date contract_end_date */
          18:
            message.contractEndDate = Date.internalBinaryRead(reader, reader.uint32(), options, message.contractEndDate);
            break;

          case
          /* string label */
          19:
            message.label = reader.string();
            break;

          case
          /* int32 client_risk_level_id */
          20:
            message.clientRiskLevelId = reader.int32();
            break;

          case
          /* string alternate_name */
          21:
            message.alternateName = reader.string();
            break;

          case
          /* proto.common.BusinessFormType business_form_type */
          22:
            message.businessFormType = reader.int32();
            break;

          case
          /* string owner_id */
          23:
            message.ownerId = reader.string();
            break;

          case
          /* int32 product_id */
          24:
            message.productId = reader.int32();
            break;

          case
          /* repeated string service_codes */
          25:
            message.serviceCodes.push(reader.string());
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "binaryReadMap10",
    value: function binaryReadMap10(map, reader, options) {
      var len = reader.uint32(),
          end = reader.pos + len,
          key,
          val;

      while (reader.pos < end) {
        var _reader$tag3 = reader.tag(),
            _reader$tag4 = _slicedToArray(_reader$tag3, 2),
            fieldNo = _reader$tag4[0],
            wireType = _reader$tag4[1];

        switch (fieldNo) {
          case 1:
            key = reader.int32();
            break;

          case 2:
            val = reader.string();
            break;

          default:
            throw new globalThis.Error("unknown map entry field for field proto.common.Account.properties");
        }
      }

      map[key !== null && key !== void 0 ? key : 0] = val !== null && val !== void 0 ? val : "";
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* proto.common.AccountId id = 1; */
      if (message.id) AccountId.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
      /* bool demo = 2; */

      if (message.demo !== false) writer.tag(2, WireType.Varint).bool(message.demo);
      /* bool readonly = 3; */

      if (message.readonly !== false) writer.tag(3, WireType.Varint).bool(message.readonly);
      /* proto.common.Account.Type type = 4; */

      if (message.type !== 0) writer.tag(4, WireType.Varint).int32(message.type);
      /* repeated proto.common.Account sub_accounts = 5; */

      for (var i = 0; i < message.subAccounts.length; i++) {
        Account.internalBinaryWrite(message.subAccounts[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
      }
      /* repeated proto.common.Account.OrderType order_types = 6; */


      if (message.orderTypes.length) {
        writer.tag(6, WireType.LengthDelimited).fork();

        for (var _i = 0; _i < message.orderTypes.length; _i++) {
          writer.int32(message.orderTypes[_i]);
        }

        writer.join();
      }
      /* bool iis = 7; */


      if (message.iis !== false) writer.tag(7, WireType.Varint).bool(message.iis);
      /* repeated proto.common.Tariff tariffs = 8 [deprecated = true]; */

      for (var _i2 = 0; _i2 < message.tariffs.length; _i2++) {
        Tariff.internalBinaryWrite(message.tariffs[_i2], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
      }
      /* proto.common.Account.AccountStatus status = 9; */


      if (message.status !== 0) writer.tag(9, WireType.Varint).int32(message.status);
      /* map<int32, string> properties = 10; */

      for (var _i3 = 0, _Object$keys = Object.keys(message.properties); _i3 < _Object$keys.length; _i3++) {
        var k = _Object$keys[_i3];
        writer.tag(10, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k)).tag(2, WireType.LengthDelimited).string(message.properties[k]).join();
      }
      /* proto.common.Account.Tariff active_tariff = 11; */


      if (message.activeTariff) Account_Tariff.internalBinaryWrite(message.activeTariff, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
      /* proto.common.Account.Tariff pending_tariff = 12; */

      if (message.pendingTariff) Account_Tariff.internalBinaryWrite(message.pendingTariff, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
      /* int32 transaq_template_id = 13; */

      if (message.transaqTemplateId !== 0) writer.tag(13, WireType.Varint).int32(message.transaqTemplateId);
      /* int32 firm_id = 14; */

      if (message.firmId !== 0) writer.tag(14, WireType.Varint).int32(message.firmId);
      /* int64 contract_id = 15; */

      if (message.contractId !== "0") writer.tag(15, WireType.Varint).int64(message.contractId);
      /* string contract_number = 16; */

      if (message.contractNumber !== "") writer.tag(16, WireType.LengthDelimited).string(message.contractNumber);
      /* google.type.Date contract_date = 17; */

      if (message.contractDate) Date.internalBinaryWrite(message.contractDate, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
      /* google.type.Date contract_end_date = 18; */

      if (message.contractEndDate) Date.internalBinaryWrite(message.contractEndDate, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
      /* string label = 19; */

      if (message.label !== "") writer.tag(19, WireType.LengthDelimited).string(message.label);
      /* int32 client_risk_level_id = 20; */

      if (message.clientRiskLevelId !== 0) writer.tag(20, WireType.Varint).int32(message.clientRiskLevelId);
      /* string alternate_name = 21; */

      if (message.alternateName !== "") writer.tag(21, WireType.LengthDelimited).string(message.alternateName);
      /* proto.common.BusinessFormType business_form_type = 22; */

      if (message.businessFormType !== 0) writer.tag(22, WireType.Varint).int32(message.businessFormType);
      /* string owner_id = 23; */

      if (message.ownerId !== "") writer.tag(23, WireType.LengthDelimited).string(message.ownerId);
      /* int32 product_id = 24; */

      if (message.productId !== 0) writer.tag(24, WireType.Varint).int32(message.productId);
      /* repeated string service_codes = 25; */

      for (var _i4 = 0; _i4 < message.serviceCodes.length; _i4++) {
        writer.tag(25, WireType.LengthDelimited).string(message.serviceCodes[_i4]);
      }

      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return Account$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.common.Account
 */


export var Account = new Account$Type(); // @generated message type with reflection information, may provide speed optimized methods

var Account_Tariff$Type = /*#__PURE__*/function (_MessageType2) {
  _inherits(Account_Tariff$Type, _MessageType2);

  var _super2 = _createSuper(Account_Tariff$Type);

  function Account_Tariff$Type() {
    _classCallCheck(this, Account_Tariff$Type);

    return _super2.call(this, "proto.common.Account.Tariff", [{
      no: 1,
      name: "id",
      kind: "scalar",
      T: 5
      /*ScalarType.INT32*/

    }, {
      no: 2,
      name: "activation_date",
      kind: "message",
      T: function T() {
        return Date;
      }
    }]);
  }

  _createClass(Account_Tariff$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        id: 0
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag5 = reader.tag(),
            _reader$tag6 = _slicedToArray(_reader$tag5, 2),
            fieldNo = _reader$tag6[0],
            wireType = _reader$tag6[1];

        switch (fieldNo) {
          case
          /* int32 id */
          1:
            message.id = reader.int32();
            break;

          case
          /* google.type.Date activation_date */
          2:
            message.activationDate = Date.internalBinaryRead(reader, reader.uint32(), options, message.activationDate);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* int32 id = 1; */
      if (message.id !== 0) writer.tag(1, WireType.Varint).int32(message.id);
      /* google.type.Date activation_date = 2; */

      if (message.activationDate) Date.internalBinaryWrite(message.activationDate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return Account_Tariff$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.common.Account.Tariff
 */


export var Account_Tariff = new Account_Tariff$Type();